import { render, staticRenderFns } from "./sSelectOrder.vue?vue&type=template&id=71934e40"
import script from "./sSelectOrder.vue?vue&type=script&lang=js"
export * from "./sSelectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports